




































































import { Cashback } from '@/models/Cashback'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { CancelarCashbackUseCase } from '@/usecases/cliente/CancelarCashbackUseCase'
import { FindCashbackUseCase } from '@/usecases/cliente/FindCashbackUseCase'
import axios, { CancelTokenSource } from 'axios'
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'
import Confirmacao from '../ui/Confirmacao.vue'
import DataTablePaginado from '../ui/data-tables/DataTablePaginado.vue'
import ListagemDeItemCashback from './ListagemDeItemCashback.vue'

@Component({
	components: {
		Confirmacao,
		ListagemDeItemCashback,
	},
})
export default class ListagemDeCashback extends Vue {
	@Prop({ type: String }) clienteId!: string
	@Prop({ type: Boolean, default: true }) hideDetail!: boolean

	@Ref() dataTable!: DataTablePaginado
	@Ref() dialogoDeListagemDeItemCashback!: ListagemDeItemCashback

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	findCashBackUseCase = new FindCashbackUseCase()
	cancelarCashbackUseCase = new CancelarCashbackUseCase()
	cancelToken: CancelTokenSource | null = null
	cashback: Cashback[] = []
	cancelando: string[] = []
	cashbackSelecionado: Cashback | null = null

	carregando = true
	loading = false
	mostrar = false

	totalRegistros = -1

	headers = [
		{ text: 'Status', value: 'statusDeCashback' },
		{ text: 'Data e hora', value: 'dataHora'},
		{ text: 'Identificador da venda', value: 'identificadorDaVenda'},
		{ text: 'Valor total creditado', value: 'valorTotalCreditado'},
		{ text: 'Id de autorização', value: 'autorizacaoId'},
		{ text: 'Ações', value: 'actions', sortable: false, align: 'center' },
	]
	
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	@Watch('mostrar', { immediate: true })
	created() {
		if(!this.mostrar) return 
		this.buscar()
	}

	@Watch('paginacao')
	async buscar () {
		try {
			this.cancelToken = axios.CancelToken.source()

			const params = {
				page: this.paginacao.page - 1,
				clienteId: this.clienteId || undefined,
				size: this.paginacao.itemsPerPage,
			}
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const pagina = await this.findCashBackUseCase.findCashBackPorCliente(params, axiosConfig)
			this.cashback = pagina.content
			this.totalRegistros = pagina.totalElements
			this.carregando = false
		} catch (error) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.carregando = false
		}
	}

	async cancelarCashback(cashback: Cashback) {
		this.loading = true
		try {
			const cashbackAtualizado = await this.cancelarCashbackUseCase.cancelar(cashback.id)
			this.cashback.map(cash =>  {
				if(cash.id === cashbackAtualizado.id) 
					cash.statusDeCashback = cashbackAtualizado.statusDeCashback
			})
			this.loading = false
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	get listaDeCashbackFormatada() {
		return this.cashback.map(cashbackFormatado => ({
			...cashbackFormatado,	
			dataHora: dateTimeToPtBrFormat(cashbackFormatado.dataHora),
			autorizacaoId: cashbackFormatado.autorizacaoId && cashbackFormatado.autorizacaoId.length > 0
				? cashbackFormatado.autorizacaoId : '-', 
		}))
	}

	statusColor(status: string) {
		if(status === 'Concluido') return 'success--text font-weight-bold'
		if(status === 'Pendente') return 'warning--text font-weight-bold'
		if(status === 'Cancelado') return 'error--text font-weight-bold'
	}
}
